import { projectTypesInversed } from '@teinor/erp/types/company/customer/customerProject'
import ModalSmallFilled from '../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import { getAllCustomerProjectTypes } from '../../../utils/reducers/getters'


interface ModalCreateCustomerProjectFromOppProps extends ModalEditComponentProps { }

const ModalCreateCustomerProjectFromOpp: React.FC<ModalCreateCustomerProjectFromOppProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const myNextStatus = allRowData?.CurrentCProjectStatusId ? getAllCustomerProjectTypes()?.[allRowData?.CustomerProjectTypeId]?.CustomerProjectStatusesByType.project?.[0]?.id : null
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/customer/customerProject/updateCustomerProject',
        data: {
            id: allRowData?.id,
            projectType: projectTypesInversed['project'],
            CurrentCProjectStatusId: myNextStatus
        }
    })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureTurnIntoCustomerProject', '¿Seguro que quieres convertir esta oportunidad a un proyecto?'),
            subtitle: t('onceTurnedProjectNotAbleToGoBack', 'Una vez convertido podrás deshacerlo'),
            buttonAccept: t('convert', 'Convertir')
        }} />
    )
}

export default ModalCreateCustomerProjectFromOpp